
import React from "react";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Search, Filter } from "lucide-react";

interface ProjectFiltersProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  stageFilter: string;
  setStageFilter: (stage: string) => void;
  statusFilter: string;
  setStatusFilter: (status: string) => void;
  sortBy: string;
  setSortBy: (sort: string) => void;
}

export default function ProjectFilters({
  searchTerm,
  setSearchTerm,
  stageFilter,
  setStageFilter,
  statusFilter,
  setStatusFilter,
  sortBy,
  setSortBy
}: ProjectFiltersProps) {
  return (
    <div className="bg-white rounded-lg shadow p-6 mb-6">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-4">
        <div className="relative">
          <Search className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
          <Input
            placeholder="Search projects..."
            className="pl-8"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        
        <div>
          <Select value={stageFilter} onValueChange={setStageFilter}>
            <SelectTrigger className="flex items-center">
              <Filter className="w-4 h-4 mr-2" />
              <SelectValue placeholder="Filter by RIBA Stage" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All Stages</SelectItem>
              <SelectItem value="0">Stage 0: Strategic Definition</SelectItem>
              <SelectItem value="1">Stage 1: Preparation and Briefing</SelectItem>
              <SelectItem value="2">Stage 2: Concept Design</SelectItem>
              <SelectItem value="3">Stage 3: Spatial Coordination</SelectItem>
              <SelectItem value="4">Stage 4: Technical Design</SelectItem>
              <SelectItem value="5">Stage 5: Manufacturing and Construction</SelectItem>
              <SelectItem value="6">Stage 6: Handover</SelectItem>
              <SelectItem value="7">Stage 7: Use</SelectItem>
            </SelectContent>
          </Select>
        </div>
        
        <div>
          <Select value={statusFilter} onValueChange={setStatusFilter}>
            <SelectTrigger className="flex items-center">
              <Filter className="w-4 h-4 mr-2" />
              <SelectValue placeholder="Filter by Status" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All Statuses</SelectItem>
              <SelectItem value="active">Active</SelectItem>
              <SelectItem value="paused">Paused</SelectItem>
              <SelectItem value="archived">Archived</SelectItem>
            </SelectContent>
          </Select>
        </div>
        
        <div>
          <Select value={sortBy} onValueChange={setSortBy}>
            <SelectTrigger>
              <SelectValue placeholder="Sort by" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="name">Name</SelectItem>
              <SelectItem value="stage">RIBA Stage</SelectItem>
              <SelectItem value="date">Start Date</SelectItem>
              <SelectItem value="progress">Progress</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
    </div>
  );
}
